module.exports = __webpack_public_path__ + "img/box-bg-l.8aa99941.png";